export const CONFIDENCE_COLORS = {
  high: '#27ae60',
  medium: '#e67e22',
  low: '#e74c3c',
} as const

export const CONFIDENCE_INDICATORS = {
  high: '🟢',
  medium: '🟡',
  low: '🔴',
} as const

export const AZURE_READ_SCORE_HEADER = 'Azure read score'
export const AZURE_READ_SCORE_TOOLTIP =
  'How clearly Azure read the text. It does not mean the value is correct.'
/** Neutral grey for Azure read score when the field has a value. */
export const AZURE_READ_SCORE_VALUE_COLOR = '#666'

export const NOT_FOUND_LABEL = 'Not found'
export const REQUIRED_FIELD_MARKER = '*'
export const CONFIDENCE_PRECISION = 1
export const CONFIDENCE_MULTIPLIER = 100
